import { SidebarState } from './types'

const state = (): SidebarState => ({
  opened: [],
  collapsed: [],
})

export default state
